<template>
  <app-wrapper :loan="loan">
    <app-header is-hidden-menu :loan="loan" medium-max-width="max-w-1000">
      <template #top>
        <div class="w-full flex items-center justify-between">
          <div class="flex-auto">
            <h2 class="text-4xl font-semibold mb-0">Verification in Progress</h2>
          </div>
          <div class="flex-initial">
            <i class="fa fa-check-circle text-success text-5xl"/>
          </div>
        </div>
      </template>
    </app-header>
    <app-body medium-max-width="max-w-500" footer>
      <template #title>
        <h3 class="text-2xl font-medium text-center mb-8">Please wait while we verify your information</h3>
      </template>

      <template #main>
        <div class="mt-4 shadow rounded-lg bg-white p-8">
          <div class="text-center">
            <p class="text-gray-700 text-lg mb-6">
              Your verification is taking longer than normal. This process may take up to 5 minutes.
            </p>
            <div class="flex flex-col items-center space-y-4 mb-6">
              <i class="fa fa-circle-notch fa-spin text-success text-3xl"/>
            </div>
            <p class="text-gray-600 text-base">
              Please keep this browser window open. We will automatically continue once verification is complete.
              If you close this window, we will reach out to you via email and/or SMS.
            </p>
          </div>
        </div>
        <!-- Conditional content when manual revert is allowed -->
        <div v-if="manualRevertAllowed" class="mt-6 shadow rounded-lg bg-yellow-50 border border-yellow-200 p-6">
          <div class="text-center">
            <div class="flex items-center justify-center mb-4">
              <i class="fa fa-exclamation-triangle text-yellow-600 text-2xl mr-2"/>
              <h4 class="text-lg font-medium text-yellow-800">It's been too long</h4>
            </div>
            <p class="text-yellow-700 mb-4">
              The verification process has stalled. Please click the button below to go back to the previous page.
            </p>
            <button 
              @click="requestStateChange"
              :disabled="loading"
              class="bg-yellow-600 hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-2 px-4 rounded-md transition-colors duration-200"
            >
              <span v-if="loading">
                <i class="fa fa-circle-notch fa-spin mr-2"/>
                Processing...
              </span>
              <span v-else>
                Go back to the previous step
              </span>
            </button>
          </div>
        </div>
      </template>
    </app-body>
  </app-wrapper>
</template>

<script>
export default {
  name: 'PlaidWaiting',
  props: {
    user: {
      type: Object,
      required: true
    },
    loan: {
      type: Object,
      required: true
    },
    manualRevertAllowed: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      refreshInterval: null,
      loading: false,
    }
  },
  mounted() {
    this.startAutoRefresh()
  },
  beforeDestroy() {
    this.clearRefreshInterval()
  },
  methods: {
    startAutoRefresh() {
      this.refreshInterval = setInterval(() => {
        window.location.reload()
      }, 20000) // Refresh every 20 seconds
    },
    clearRefreshInterval() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
      }
    },
    requestStateChange() {
        this.loading = true;
        this.$http.post(`/signup/restart-plaid/${this.loan.id}`).then(response => {
            this.loading = false;
            window.location.reload()
        }).catch(error => {
            this.loading = false;
            // TODO handle error
        });
    }
  }
}
</script>

<style scoped>
.animate-spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>